export const TEST_ID = 'kmlImport';
